// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"d640d6d7","320":"e87e2443","491":"e9178eed","844":"5d1fb312","976":"34b1e9c8"}[chunkId] + ".css";
};